// extracted by mini-css-extract-plugin
export var leftAlign = "_h-2";
export var popper = "_h-0";
export var subtitle = "_h-1";